!(function() {
	var e = window.Mixcloud,
		n = {
			noConflict: function() {
				return (window.Mixcloud = e), n;
			},
		};
	window.Mixcloud = n;
})(),
	(window.Mixcloud.Callbacks = function() {
		var e = [];
		return {
			apply: function(n, t) {
				for (var o = 0; o < e.length; o++) e[o].apply(n, t);
			},
			external: {
				on: function(n) {
					e.push(n);
				},
				off: function(n) {
					for (var t = 0; t < e.length; t++)
						if (e[t] === n) {
							e.splice(t, 1);
							break;
						}
				},
			},
		};
	}),
	(function() {
		function e(e, n) {
			return (typeof e)[0] === n;
		}
		var n = 1;
		window.Mixcloud.Deferred = function() {
			function t(e) {
				r(n, e);
			}
			function o(e) {
				r(2, e);
			}
			function r(r, c) {
				if (!d) {
					if (((l.resolve = l.reject = function() {}), r === n)) {
						if (c === l.promise) return void o(new TypeError());
						if (c instanceof a) return void c.then(t, o);
						if (e(c, "f") || e(c, "o")) {
							var f;
							try {
								f = c.then;
							} catch (e) {
								return void o(e);
							}
							if (e(f, "f")) {
								try {
									f.call(c, t, o);
								} catch (e) {
									d || o(e);
								}
								return;
							}
						}
					}
					(u = c), (d = r), i();
				}
			}
			function i() {
				setTimeout(function() {
					for (var e = 0; e < f.length; e++) f[e][d - 1].call(void 0, u);
					f = [];
				}, 0);
			}
			function c(n, t) {
				function o(e) {
					return function(n) {
						try {
							r.resolve(e.call(this, n));
						} catch (e) {
							r.reject(e);
						}
					};
				}
				var r = window.Mixcloud.Deferred();
				return (
					f.push([
						e(n, "f")
							? o(n)
							: function(e) {
									r.resolve(e);
							  },
						e(t, "f")
							? o(t)
							: function(e) {
									r.reject(e);
							  },
					]),
					d && i(),
					r.promise
				);
			}
			function a() {
				this.then = c;
			}
			var u,
				f = [],
				d = 0,
				l = { resolve: t, reject: o, promise: new a() };
			return l;
		};
	})(),
	(function(e) {
		function n(n) {
			if (n.origin === o || n.origin === e.location.origin) {
				var t;
				try {
					t = JSON.parse(n.data);
				} catch (e) {
					return;
				}
				if ("playerWidget" === t.mixcloud)
					for (var r = 0; r < i.length; r++)
						i[r].window === n.source && i[r].callback(t.type, t.data);
			}
		}
		function t(e, n) {
			e.postMessage(JSON.stringify(n), o);
		}
		var o = "https://www.mixcloud.com",
			r = 0,
			i = [];
		(e.Mixcloud.PlayerWidget = function(n) {
			function o(e, n) {
				"ready" === e
					? t(u, { type: "getApi" })
					: "api" === e
					? c(n)
					: "event" === e
					? d[n.eventName].apply(s, n.args)
					: "methodResponse" === e &&
					  l[n.methodId] &&
					  (l[n.methodId].resolve(n.value), delete l[n.methodId]);
			}
			function c(n) {
				var t;
				for (t = 0; t < n.methods.length; t++)
					s[n.methods[t]] = a(n.methods[t]);
				for (t = 0; t < n.events.length; t++)
					(d[n.events[t]] = e.Mixcloud.Callbacks()),
						(s.events[n.events[t]] = d[n.events[t]].external);
				f.resolve(s);
			}
			function a(n) {
				return function() {
					return (
						r++,
						(l[r] = e.Mixcloud.Deferred()),
						t(u, {
							type: "method",
							data: {
								methodId: r,
								methodName: n,
								args: Array.prototype.slice.call(arguments),
							},
						}),
						l[r].promise
					);
				};
			}
			var u = n.contentWindow,
				f = e.Mixcloud.Deferred(),
				d = {},
				l = {},
				s = { ready: f.promise, events: {} };
			return i.push({ window: u, callback: o }), t(u, { type: "getApi" }), s;
		}),
			e.addEventListener
				? e.addEventListener("message", n, !1)
				: e.attachEvent("onmessage", n);
	})(window);
